// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Call__wrapper-cf2630 {
  flex: 1;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  width: 100%;
}

.Call__left-dd05cd {
  margin: 0;
}

.Call__initiator-d27ef9 {
  color: var(--base-120);
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
  flex-shrink: 1;
  display: flex;
  overflow: hidden;
  align-items: center;
}
.Call__initiator-d27ef9:hover, .Call__initiator-d27ef9:active {
  text-decoration: underline;
}
@supports (display: block) {
  .Call__initiator-d27ef9:focus-visible {
    text-decoration: underline;
  }
}

.Call__container-fc9986 {
  background-color: var(--incoming-bubble-bg);
  padding: 8px 12px;
  border-radius: 16px;
  flex: 0;
  max-width: 352px;
  box-sizing: border-box;
}

.Call__title-c382ab {
  white-space: pre;
  overflow: hidden;
  display: flex;
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--incoming-bubble-text-primary);
}

.Call__meta-d32142 {
  font: var(--font-caption-2);
  letter-spacing: var(--font-spacing-caption-2);
  color: var(--incoming-bubble-text-secondary);
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
}

.Call__icon-b8a4cb {
  fill: var(--success-40);
}

.Call__cancel-ad9c1d {
  fill: var(--warning-40);
}

.Call__missed-c620bc {
  fill: var(--danger-40);
}

.Call__name-b17830 {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Payload/Call/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AACF;AAAE;EAEE,0BAAA;AACJ;AACE;EACE;IACE,0BAAA;EACJ;AACF;;AAGA;EACE,2CAAA;EACA,iBAAA;EACA,mBAAA;EACA,OAAA;EACA,gBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,wBAAA;EACA,0CAAA;EACA,0CAAA;AAAF;;AAGA;EACE,2BAAA;EACA,6CAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,uBAAA;AAAF;;AAGA;EACE,uBAAA;AAAF;;AAGA;EACE,sBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;AAAF","sourcesContent":[".wrapper {\n  flex: 1;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.left {\n  margin: 0;\n}\n\n.initiator {\n  color: var(--base-120);\n  font-weight: bold;\n  cursor: pointer;\n  text-decoration: none;\n  flex-shrink: 1;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  &:hover,\n  &:active {\n    text-decoration: underline;\n  }\n  @supports (display: block) {\n    &:focus-visible {\n      text-decoration: underline;\n    }\n  }\n}\n\n.container {\n  background-color: var(--incoming-bubble-bg);\n  padding: 8px 12px;\n  border-radius: 16px;\n  flex: 0;\n  max-width: 352px;\n  box-sizing: border-box;\n}\n\n.title {\n  white-space: pre;\n  overflow: hidden;\n  display: flex;\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--incoming-bubble-text-primary);\n}\n\n.meta {\n  font: var(--font-caption-2);\n  letter-spacing: var(--font-spacing-caption-2);\n  color: var(--incoming-bubble-text-secondary);\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.icon {\n  fill: var(--success-40);\n}\n\n.cancel {\n  fill: var(--warning-40);\n}\n\n.missed {\n  fill: var(--danger-40);\n}\n\n.name {\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Call__wrapper-cf2630`,
	"left": `Call__left-dd05cd`,
	"initiator": `Call__initiator-d27ef9`,
	"container": `Call__container-fc9986`,
	"title": `Call__title-c382ab`,
	"meta": `Call__meta-d32142`,
	"icon": `Call__icon-b8a4cb`,
	"cancel": `Call__cancel-ad9c1d`,
	"missed": `Call__missed-c620bc`,
	"name": `Call__name-b17830`
};
module.exports = ___CSS_LOADER_EXPORT___;
